export function ImgIcon() {
  return (
    <svg viewBox="0 0 20 20" fill="currentColor">
      <path d="M5,15L15,15L15,10L13,8L8,13L5,10L5,15Z" />
      <circle cx="8" cy="7" r="2" />
    </svg>
  );
}
